// removed by extract-text-webpack-plugin
module.exports = {"notes":"NoteList__notes___2sLf6","newNote":"NoteList__newNote___XAkMV","note":"NoteList__note___3SSPz","noteContent":"NoteList__noteContent___26R17","noteDate":"NoteList__noteDate___3d2WF","delete":"NoteList__delete___1sX12","normal":"NoteList__normal___1B0GV","technical":"NoteList__technical___ParfJ","emptyState":"NoteList__emptyState___38Aak"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NoteList/NoteList.scss
// module id = 1186
// module chunks = 1